import type { ReactNode } from 'react'

import { ModuleUnavailable } from '@/components/common/ModuleUnavailable'
import { PageLoader } from '@/components/common/PageLoader'
import { hasModule, useEntitlements } from '@/features/entitlements/hooks'
import type { ModuleCode } from '@/features/entitlements/types'

/**
 * SA-8 (Sección 17) — protección de URL directa: si un usuario escribe
 * manualmente la ruta de un módulo deshabilitado, muestra
 * `ModuleUnavailable` y NUNCA carga los datos del módulo (los hijos ni
 * siquiera se montan). Espera a que `useEntitlements()` resuelva antes
 * de decidir — evita un parpadeo de contenido que luego se oculta.
 * Combinar con `PermissionRoute` cuando ambos apliquen: son
 * independientes, ninguno sustituye al otro (Sección objetivo).
 */
export function ModuleRoute({ module, children }: { module: ModuleCode; children: ReactNode }) {
  const { data, isLoading } = useEntitlements()

  if (isLoading) return <PageLoader />
  if (!hasModule(data, module)) return <ModuleUnavailable />

  return children
}
